import React from "react";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import {Button, FormControl, FormGroup, FormLabel} from "react-bootstrap";
import Content from "../blocks/Content";

function Settings(props) {
    return <div className={"Screen Settings"}>
            <Content className="container">
                <FormGroup>
                    <FormLabel className="Label">
                        {props.t('Server')}
                        <FormControl
                            type="text"
                            minLength="1"
                            required
                            id="server_host"
                            name="server_host"
                            onInput={props.onChange}
                            defaultValue={props.formValues.server_host}
                            className={"Control Field mt-2"} />
                    </FormLabel>
                </FormGroup>
                <FormGroup>
                    <FormLabel className="Label">
                        {props.t('Window name')}
                        <FormControl
                            type="text"
                            minLength="1"
                            required
                            id="window_name"
                            name="window_name"
                            onInput={props.onChange}
                            defaultValue={props.formValues.window_name}
                            className={"Control Field mt-2"} />
                    </FormLabel>
                </FormGroup>
                <Button type="submit" onClick={props.handleSubmit} disabled={!props.formValid} className="Btn SubmitBtn Btn_success">
                    {props.t('Save')}
                </Button>
            </Content>
           </div>
}

const mapStateToProps = (store) => {
    return {};
};

export default connect(mapStateToProps)(withTranslation()(Settings));